export default class Section {
    id;
    sort_order;
    title;
    contents;
    
    constructor(id){
        this.title = "";
        this.id = id;
        this.contents = [];
    }
}
